export const DEFAULT_DADATA_DELAY = 1500;
